/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from 'semantic-ui-react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';

import { useGoogleAnalytics } from 'volto-google-analytics';
const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>About NITheCS</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/who-we-are">Who we are</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/our-people">Our people</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/opportunities">Opportunities</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/policy-documents/nithecs-roadmap-20201120.pdf/@@download/file/@@download/file" target="_blank">NITheCS Roadmap</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Research</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/research/publications">Publications</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/research/nithecs-focus-areas">Focus Areas</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Associates</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/our-people/associates">Search associates</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/our-people/associates#nominations">Nominate an associate</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Students</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/opportunities">Opportunties</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/training">Training</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Newsroom</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/news">News</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/newsroom/engagement">Engagements</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/events">Events</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Quick Links</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/contact">Contact Us</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="#">Join our mailing list</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="#">Privacy policy</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="#">Terms of use</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={3} textAlign="left"></GridColumn>
              <GridColumn width={3} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://twitter.com/nithecs"
                            target="_blank"
                            title="X"
                          >
                            <i class="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/channel/UCwGLdESE9yLrYzIiwOfcW5g"
                            target="_blank"
                            title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://facebook.com/NITheCS/"
                            target="_blank"
                            title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.threads.net/@nithecs"
                            target="_blank"
                            title="Threads"
                          >
                            <i class="bi bi-threads"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.instagram.com/nithecs/"
                            target="_blank"
                            title="Instagram"
                          >
                            <i class="bi bi-instagram"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.linkedin.com/company/65282442"
                            target="_blank"
                            title="LinkedIn"
                          >
                            <i class="bi bi-linkedin"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://bsky.app/profile/nithecs.bsky.social"
                            target="_blank"
                            title="Bluesky"
                          >
                            <i class="bi bi-bluesky"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} National Institute for Theoretical and Computational Sciences (NITheCS) {current_year}"
                        defaultMessage="{copyright} National Institute for Theoretical and Computational Sciences (NITheCS) {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of <a href="https://www.pexels.com" target="_blank">Pexels</a> & <a href="https://unsplash.com" target="_blank">Unsplash</a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-circle-fill"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
